/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */
import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import './style.scss';
import { setAllToMaxHeight } from '../../helper.js';
import { Navigation }from 'swiper/modules';

document.addEventListener('DOMContentLoaded', () => {
    const featReviews = document.querySelectorAll('.featured-reviews');
    if(featReviews){

        featReviews.forEach(featReview => { 
            const headers = featReview.querySelectorAll('.header');
            setAllToMaxHeight(headers);
            window.addEventListener('resize', ()=> {
                setAllToMaxHeight(headers);
            });

            const swiperInstance = new Swiper(featReview.querySelector('.swiper'), {
                navigation: false,
                slidesPerView: 1.25,
                modules: [Navigation],
                navigation: true,
                spaceBetween: 15,
                centeredSlides: true,
                initialSlide: 1, 
                loop: true,
                navigation: {
                    prevEl: featReview.querySelector('.swiper-button-prev'),
                    nextEl: featReview.querySelector('.swiper-button-next'),
                },
                breakpoints: {
                    400: {
                        spaceBetween: 50,
                        slidesPerView: 'auto',
                    }
                }
            });

            setUpArrows(featReview, swiperInstance );
            window.addEventListener('resize', ()=>{
                setUpArrows(featReview, swiperInstance );
            })
        }
        );
    }
});


function setUpArrows(featReview,swiperInstance){
    console.log('setUpArrows');
    let offset;
    const swiper_width = featReview.querySelector('.swiper').offsetWidth;
    console.log(swiper_width);
    offset = (swiper_width / 2);
    offset -= swiperInstance.params.spaceBetween/2;
    offset -= 10;
    console.log(swiperInstance.params.spaceBetween);
    featReview.style.setProperty('--arrow-offset', offset+'px');
}